import {
  PencilSquareIcon,
  PlusCircleIcon,
  TrashIcon,
} from "@heroicons/react/24/outline";
import { EditProcessGroupTypes } from "@via/pages/projects/pipelines/workflow/utils/constants.tsx";
import { Tooltip } from "react-tooltip";

export const EditProcessToolbar = ({
  type = EditProcessGroupTypes.MenuGroup,
  readOnly,
  onCreate,
  onEdit,
  onDelete,
}) => {
  const actionType =
    type === EditProcessGroupTypes.MenuGroup ? "MenuGroup" : "Parameter";
  const label =
    type === EditProcessGroupTypes.MenuGroup ? "Menu Group" : "Parameter";
  return (
    <div className="flex flex-row items-center">
      <span className="isolate mb-1 inline-flex rounded-md pl-4 text-sm shadow-sm">
        <button
          id={`create${actionType}`}
          type="button"
          disabled={readOnly}
          onClick={onCreate}
          className="folder-actions-button rounded-l-md">
          <PlusCircleIcon className="folder-actions-icon" />
        </button>
        <Tooltip
          anchorSelect={`#create${actionType}`}
          content={`Create ${label}`}
          place="top"
        />
        <button
          id={`edit${actionType}`}
          type="button"
          disabled={readOnly}
          onClick={onEdit}
          className="folder-actions-button -ml-px">
          <PencilSquareIcon className="folder-actions-icon" />
        </button>
        <Tooltip
          anchorSelect={`#edit${actionType}`}
          content={`Edit ${label}`}
          place="top"
        />
        <button
          id={`delete${actionType}`}
          type="button"
          disabled={readOnly}
          onClick={onDelete}
          className="folder-actions-button -ml-px rounded-r-md">
          <TrashIcon className="folder-actions-icon" />
        </button>
        <Tooltip
          anchorSelect={`#delete${actionType}`}
          content={`Delete ${label}`}
          place="top"
        />
      </span>
    </div>
  );
};
